import {
	Component,
	OnInit,
	Input,
	OnDestroy,
	Output,
	EventEmitter,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'eze-prefill-form',
	templateUrl: './prefill-form.component.html',
	styleUrls: ['./prefill-form.component.css'],
})
export class PrefillFormComponent implements OnInit, OnDestroy {
	@Input()
	profile;

	@Input()
	formReference: FormGroup;

	private selectedUserIndex = '';
	formControl = new FormControl(this.selectedUserIndex);
	private formSubscription: Subscription;

	showWarning = false;

	@Output() selectedPrefill = new EventEmitter();

	constructor() {}

	ngOnInit() {
		this.formSubscription = this.formControl.valueChanges
			.pipe(filter((userIndex) => userIndex !== ''))
			.subscribe((userIndex) => {
				this.selectedUserIndex = userIndex;

				if (this.formReference.dirty) {
					this.showWarning = true;
					return;
				}

				this.updateFormWithUser(userIndex);
			});
	}

	forceUpdate() {
		this.updateFormWithUser(this.selectedUserIndex);
		this.showWarning = false;
	}

	cancelUpdate() {
		this.showWarning = false;
	}

	ngOnDestroy() {
		if (this.formSubscription) {
			this.formSubscription.unsubscribe();
		}
	}

	private updateFormWithUser(userIndex) {
		this.selectedPrefill.emit();
		switch (userIndex) {
			case '0':
				this.updateForm(this.profile);
				break;
			case '-1':
				this.updateForm({});
				break;
			default:
				break;
		}
	}

	private updateForm(user) {
		this.formReference.reset();
		if (!user.weight) {
			user.weight = '1';
		}
		this.formReference.patchValue(user);
		this.formReference.markAsPristine();
	}
}
